<template>
  <div class="ReadableTable">
    <el-table
      :data="tableData"
      ref="tableRef"
      @header-dragend="headerdragend"
      :summary-method="getSummaries"
      :height="tableHeight"
      show-summary
      border
      style="width: 100%"
      :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'16px',height:'37px',padding:'0',fontWeight: 'bold'}"
    >
      <el-table-column width="80" height="500" align="center" fixed="left">
        <template slot="header">
          <i
            class="el-icon-s-tools"
            @click="tableConfigShow=true"
            style="color:#2594ff;font-size:18px"
          ></i>
        </template>
        <template slot-scope="scope">{{scope.$index +1 }}</template>
      </el-table-column>
      <el-table-column width="100" align="center" label="操作" fixed="left">
        <template>
          <el-button type="text" disabled>新增</el-button>
          <el-button type="text" disabled>移除</el-button>
        </template>
      </el-table-column>
      <template v-for="(item,index) in ObtainHeader">
        <el-table-column
          v-if=" item.Show == true "
          align="center"
          :key="index"
          :prop="item.Key"
          :label="item.Rename"
          :width="item.Width==''?'200':item.Width"
        ></el-table-column>
      </template>F
    </el-table>
    <HeaderElastic
      :show.sync="tableConfigShow"
      :tableData="ObtainHeader"
      v-bind="$attrs"
      v-on="$listeners"
      @restoreDefault="restoreDefault"
    />
  </div>
</template>

<script>
import tool from "@/utils/tool.js";
export default {
  data() {
    return {
      Data: this.tableData, // 表格数据
      tableConfigShow: false, //是否显示表头配置弹出框
      ObtainHeader: this.Obtain // 表格表头数据
    };
  },
  props: {
    tableData: Array,
    Obtain: Array,
    tableHeight: {
      type: String,
      default: "330px" //window.innerHeight - 400 + "px"
    } // 动态高度
  },
  methods: {
    // 恢复默认
    restoreDefault(val) {
      this.ObtainHeader = val;
    },
    headerdragend(newWidth, oldWidth, column, event) {
      let Baseno = false;
      this.ObtainHeader.map(item => {
        if (item.Key == column.property) {
          Baseno = item.BaseNo;
          return;
        }
      });
      if (Baseno != false) {
        let jparams = {
          user_id: tool.getLocal("userid"),
          session_id: tool.getLocal("sessionid"),
          Model: this.$attrs.pargam.Model,
          data: [
            {
              BaseNo: Baseno,
              Width: newWidth
            }
          ]
        };
        this.request
          .post("/index/Settings/modify_function_fields", {
            jparams: JSON.stringify(jparams)
          })
          .then(res => {})
          .catch(err => {
            console.log(err);
          });
      }
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总计";
          return;
        }
        const values = data.map(item => {
          if (
            column.property == "Qty" ||
            column.property == "AQty" ||
            column.property == "DiscountPrice" ||
            column.property == "Total" ||
            column.property == "ATotal" ||
            column.property == "DiscountTotal"
          ) {
            // console.log(Number(item[column.property]));
            if (Number(item[column.property]) != "undefined") {
              return Number(item[column.property]);
            }
          }
        });
        if (!values.every(value => isNaN(value))) {
          sums[index] = this.sum(values);
          sums[index] += "";
        }
      });

      return sums;
    },
    // 累加数组中的number
    sum(arr) {
      var s = 0;
      for (var i = arr.length - 1; i >= 0; i--) {
        if (item[e] == "****") {
          s = "****";
        } else {
          s += arr[i];
          s = Number(s).toFixed(tool.getLocal("get_config").moneyPoint);
        }
      }
      return s;
    }
  },
  watch: {
    ObtainHeader: {
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          this.$refs.tableRef.doLayout();
        });
      },
      deep: true
    },
    tableData: {
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          this.$refs.tableRef.doLayout();
        });
      },
      deep: true
    }
  }
};
</script>

<style  lang="less" scoped>
/deep/ .el-table--medium td,
.el-table--medium th {
  padding: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Table/ReadableTable/ReadableTable.vue